import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.sections}>
          <div style={styles.section}>
            <h4 style={styles.sectionTitle}>About RaiseX</h4>
            <p style={styles.sectionText}>
              RaiseX — Trust, Raised on Chain. A decentralized crowdfunding platform built on blockchain technology. 
              We enable transparent, secure, and trustless fundraising for causes that matter.
            </p>
          </div>
          
          <div style={styles.section}>
            <h4 style={styles.sectionTitle}>Quick Links</h4>
            <div style={styles.links}>
              <Link to="/faq" style={styles.link}>FAQ</Link>
              <Link to="/terms" style={styles.link}>Terms & Conditions</Link>
              <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
            </div>
          </div>
          
          <div style={styles.section}>
            <h4 style={styles.sectionTitle}>Connect</h4>
            <div style={styles.socialLinks}>
              <a href="https://github.com/amitsudhir/raisex" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
                <svg style={styles.socialIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
                GitHub
              </a>
              <div style={styles.socialLinkDisabled}>
                <svg style={styles.socialIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                LinkedIn
              </div>
              <a href="https://x.com/iam_sudhiramit" target="_blank" rel="noopener noreferrer" style={styles.socialLink}>
                <svg style={styles.socialIcon} viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
                X
              </a>
            </div>
          </div>
        </div>
        
        <div style={styles.bottom}>
          <div style={styles.bottomText}>
            Built with blockchain technology — RaiseX
          </div>
          <div style={styles.bottomText}>
            © 2026 RaiseX. Decentralized and open source.
          </div>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
    color: "white",
    marginTop: "4rem",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "3rem 1rem 1rem",
  },
  sections: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "2rem",
    marginBottom: "2rem",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  sectionTitle: {
    fontSize: "1.2rem",
    fontWeight: "600",
    margin: 0,
    color: "#f9fafb",
  },
  sectionText: {
    fontSize: "0.9rem",
    lineHeight: "1.6",
    color: "#d1d5db",
    margin: 0,
  },
  links: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  link: {
    color: "#d1d5db",
    textDecoration: "none",
    fontSize: "0.9rem",
    transition: "color 0.3s ease",
  },
  socialLinks: {
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  socialLink: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    color: "#d1d5db",
    textDecoration: "none",
    fontSize: "0.9rem",
    transition: "color 0.3s ease",
    padding: "0.5rem 0",
  },
  socialLinkDisabled: {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    color: "#6b7280",
    fontSize: "0.9rem",
    padding: "0.5rem 0",
    cursor: "not-allowed",
    opacity: 0.6,
  },
  socialIcon: {
    width: "20px",
    height: "20px",
    color: "currentColor",
    transition: "color 0.3s ease",
  },
  bottom: {
    borderTop: "1px solid #374151",
    paddingTop: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "1rem",
  },
  bottomText: {
    fontSize: "0.85rem",
    color: "#9ca3af",
  },
};

export default Footer;